// helper to get assets CDN URL from various sources
import { getPublicEnv, PublicEnvKeys } from './getPublicEnv';

function getAssetsCdnUrl(): string {
  return getPublicEnv(PublicEnvKeys.ASSETS_PATH, 'https://assets.unifyapps.com');
}

export const UA_ASSETS_PATH = getAssetsCdnUrl();
